/*
 * A one-shot handoff from Login to AdminMaster.
 *
 * The AI license notification greets an admin who has just signed in, so it
 * cannot key off AdminMaster mounting — that also happens on every page
 * refresh and on the way back from Settings. Login raises the flag only on a
 * fresh sign-in (the "already have a token" branch that a reload takes never
 * touches it), and reading it clears it, so it fires exactly once per login.
 */
const PENDING_KEY = "aiLicenseAlertPending";

export const markAiLicenseAlertPending = () => {
  localStorage.setItem(PENDING_KEY, "true");
};

// Returns whether this mount followed a login, and clears the flag so the
// next mount does not.
export const consumeAiLicenseAlertPending = () => {
  const pending = localStorage.getItem(PENDING_KEY) === "true";
  if (pending) {
    localStorage.removeItem(PENDING_KEY);
  }
  return pending;
};
